import React from 'react';
import classnames from 'classnames';
import s from './ActionBarIcon.scss';
export var ActionBarIcon = function (_a) {
    var Icon = _a.icon, label = _a.label, isActive = _a.isActive, canFoldLabel = _a.canFoldLabel;
    return (React.createElement(React.Fragment, null,
        React.createElement(Icon, { className: classnames(s['icon'], isActive && s['active']), customSizable: true, disableDefaultColors: true }),
        label && (React.createElement("span", { className: classnames(s['label'], canFoldLabel && s['foldable']) }, label))));
};
ActionBarIcon.displayName = 'ActionBarIcon';
export default ActionBarIcon;
//# sourceMappingURL=ActionBarIcon.js.map